var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPreviousCerulean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.667 3.815H3.17l2.651-2.66L4.778.112.333 4.556 4.778 9l1.044-1.044-2.651-2.66h10.496V3.816z",
    fill: "#1056FB"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMy42NjY4IDMuODE1MDNIMy4xNzA1M0w1LjgyMjM4IDEuMTU1NzdMNC43Nzc5NCAwLjExMTMyOEwwLjMzMzQ5NiA0LjU1NTc3TDQuNzc3OTQgOS4wMDAyMkw1LjgyMjM4IDcuOTU1NzdMMy4xNzA1MyA1LjI5NjUxSDEzLjY2NjhWMy44MTUwM1oiIGZpbGw9IiMxMDU2RkIiLz4KPC9zdmc+Cg==";
export { SvgArrowPreviousCerulean as ReactComponent };